/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99.9% accuracy → Phred+33 char '?'.`)
};

const es_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99.9% de precisión → carácter Phred+33 '?'.`)
};

const de_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99,9% Genauigkeit → Phred+33-Zeichen '?'.`)
};

const nl_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99,9% nauwkeurigheid → Phred+33-teken '?'.`)
};

const fr_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99,9 % de précision → caractère Phred+33 '?'.`)
};

const it_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99,9% di accuratezza → carattere Phred+33 '?'.`)
};

const pt_br2_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99,9% de precisão → caractere Phred+33 '?'.`)
};

const pt_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99,9% de precisão → carácter Phred+33 '?'.`)
};

const ja_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 精度99.9% → Phred+33文字 '?'。`)
};

const zh_phred_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 → 1e-3 → 99.9% 准确率 → Phred+33 字符 '?'。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_ex2", locale)
	if (locale === "en") return en_phred_ex2(inputs)
	if (locale === "es") return es_phred_ex2(inputs)
	if (locale === "de") return de_phred_ex2(inputs)
	if (locale === "nl") return nl_phred_ex2(inputs)
	if (locale === "fr") return fr_phred_ex2(inputs)
	if (locale === "it") return it_phred_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_phred_ex2(inputs)
	if (locale === "pt") return pt_phred_ex2(inputs)
	if (locale === "ja") return ja_phred_ex2(inputs)
	return zh_phred_ex2(inputs)
};